import * as Ably from 'ably';
import store from '../store';
import { API } from '../axios';

let client = null;

// Den Ably-Token holt jede Authentifizierung frisch über die API: So gilt immer der aktuelle
// Club-Token aus dem Store (Refresh-Token, Re-Login des Monitors) statt eines beim Start
// fest eingebauten Headers, mit dem Ably nach einem Token-Wechsel endlos 401 bekam.
function requestAblyToken(tokenParams, callback) {
    API.post('club/ably/token')
        .then(resp => callback(null, resp.data))
        .catch(err => callback((err && err.message) || 'Ably-Token konnte nicht geholt werden', null));
}

export function initializeAblyClient() {
    closeAblyClient();

    client = new Ably.Realtime({
        authCallback: requestAblyToken,
        autoConnect: true,  // Automatische Verbindung beim Erstellen
        recover: (lastConnectionDetails, cb) => {
            console.log('Recovering Ably session');
            cb(true); // Automatisch versuchen, die Session zu rekonstruieren
        }
    });

    return client;
}

export function closeAblyClient() {
    if (client) {
        client.close();
        client = null;
    }
}

// Abgemeldet (Logout, 401 ohne Refresh): Verbindung schließen, sonst versucht Ably es ohne Token weiter
store.watch(
    (state, getters) => getters['ClubAuth/isClubToken'],
    token => {
        if (!token) closeAblyClient();
    }
);

export {client as default};
